"use strict";import{IconCross400 as o}from"../src/elements/IconCross400.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-icon-cross400",o);
//# sourceMappingURL=sp-icon-cross400.js.map
